import { render, staticRenderFns } from "./UploadPreview.vue?vue&type=template&id=c6423a88&scoped=true&"
import script from "./UploadPreview.vue?vue&type=script&lang=js&"
export * from "./UploadPreview.vue?vue&type=script&lang=js&"
import style0 from "./UploadPreview.vue?vue&type=style&index=0&id=c6423a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6423a88",
  null
  
)

export default component.exports